/* eslint-disable no-case-declarations */
import axios from 'axios';
import { takeLatest, call, put } from 'redux-saga/effects';
import { getShop, isCartPage } from '../../../../common/pageData';
import {
  REMOVE_FROM_CART,
  REMOVE_FROM_CART_SUCCESS,
  REMOVE_FROM_CART_ERROR,
  REMOVE_FROM_CART_API,
  FETCH_CART_API,
} from '../constants';
import { setOpenDrawer } from '../../../../common/settings';
import { refreshAJAXCart } from '../../../../common/cart';
import { logger } from '../../../../common/logger';
import { reloadPage } from '../../../../pageHelper';

function* removeFromCartWorker(action) {
  try {
    const httpCartArgs = [FETCH_CART_API];
    const {
      data: { items },
    } = yield call(axios.get, ...httpCartArgs);
    const removeReq = {};

    for (let i = 0; i < items.length; i++) {
      if (items[i].id === action.variant.id) {
        removeReq['quantity'] = items[i].quantity - 1;
        removeReq['line'] = i + 1;
        if (items[i].properties && items[i].properties['_mr']) {
          break;
        }
      }
    }

    // let formData = {
    //   id: action.variant.id.toString(),
    //   quantity: currentQuantity - 1,
    // };
    const httpArgs = [REMOVE_FROM_CART_API, removeReq];
    const { status } = yield call(axios.post, ...httpArgs);
    if (status === 200) {
      const datapack = {
        mrOfferID: action.mrOfferID,
        variant_id: action.variant.id,
        product_id: action.product_id,
        variant_title: action.variant.title,
        product_title: action.product_title,
        isEmbedded: action.isEmbedded,
      };
      yield put({ type: REMOVE_FROM_CART_SUCCESS, datapack });
      refreshAJAXCart();
      // reload page for this shop
      if (action.isEmbedded && getShop() === 'ruglove-co-uk.myshopify.com') {
        reloadPage();
      }

      if (
        (action.offerType === 'crossell' || action.offerType === 'freegift') &&
        action.theme.isRefreshPageAfterProductAddition &&
        action.isEmbedded
      ) {
        if (
          action.triggerType !== 'product' &&
          action.triggerType !== 'product_page' &&
          !isCartPage()
        ) {
          setOpenDrawer('true');
        }
        logger.log('refresh initiated line 68');
        reloadPage();
      }
    } else {
      yield put({ type: REMOVE_FROM_CART_ERROR, variantid: action.variant.id });
    }
  } catch (e) {
    logger.log(e);
    yield put({ type: REMOVE_FROM_CART_ERROR, variantid: action.variant.id });
  }
}

export default function* removeFromCartWatcher() {
  yield takeLatest(REMOVE_FROM_CART, removeFromCartWorker);
}
